var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-button',{staticClass:"btn-create",attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.callSetModel}},[_c('i',{staticClass:"icon-plus"}),_vm._v(" "+_vm._s(_vm.create_spanish(_vm.model_name))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }